import React, { ChangeEvent, FC } from 'react';
import { Form, Modal, Select, Tooltip } from 'antd';

type Props = {
  showModal: boolean;
  resolution: string;
  publishing: boolean;
  setResolution: (value: string) => void;
  onOk: () => void;
  onCancel: () => void;
};

const Option = Select.Option;

const resolutionOptions = ['QA reviewed', 'ML annotated']; //If change, change on BE also
const resolutionOptionsTooltips: any = {
  'QA reviewed':
    'Only reviewed findings will be published in Results & Reporting module. This means all unreviewed AI findings will be removed from Results & Reporting.',
  'ML annotated': 'All findings will be published in Results & Reporting module, including not reviewed AI findings.'
};

const ResolutionModal: FC<Props> = ({ showModal, resolution, publishing, setResolution, onOk, onCancel }) => {
  if (!resolution) setResolution(resolutionOptions[0]);

  return (
    <Modal
      className='bulk-update'
      title='Publish Turbines'
      okButtonProps={{ loading: publishing }}
      onOk={onOk}
      visible={showModal}
      onCancel={onCancel}
    >
      <div style={{ padding: '0 15px' }}>
        <Form.Item label='Resolution' colon={false}>
          <Select
            showSearch
            style={{ width: '100%' }}
            onChange={(e: any) => setResolution(e.toString())}
            value={resolution ? resolution : resolutionOptions[0]}
          >
            {resolutionOptions.map(value => (
              <Option className={'extendedOption'} key={value} value={value}>
                <Tooltip placement='right' title={resolutionOptionsTooltips[value]}>
                  <div>{value}</div>
                </Tooltip>
              </Option>
            ))}
          </Select>
        </Form.Item>
      </div>
    </Modal>
  );
};

export default ResolutionModal;
